import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './religion.reducer';

export const ReligionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const religionEntity = useAppSelector(state => state.religion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="religionDetailsHeading">
          <Translate contentKey="apiLocationApp.religion.detail.title">Religion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{religionEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.religion.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{religionEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.religion.date">Date</Translate>
            </span>
          </dt>
          <dd>{religionEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.religion.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{religionEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.religion.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{religionEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.religion.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{religionEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="christian">
              <Translate contentKey="apiLocationApp.religion.christian">Christian</Translate>
            </span>
          </dt>
          <dd>{religionEntity.christian}</dd>
          <dt>
            <span id="buddhist">
              <Translate contentKey="apiLocationApp.religion.buddhist">Buddhist</Translate>
            </span>
          </dt>
          <dd>{religionEntity.buddhist}</dd>
          <dt>
            <span id="hindu">
              <Translate contentKey="apiLocationApp.religion.hindu">Hindu</Translate>
            </span>
          </dt>
          <dd>{religionEntity.hindu}</dd>
          <dt>
            <span id="jewish">
              <Translate contentKey="apiLocationApp.religion.jewish">Jewish</Translate>
            </span>
          </dt>
          <dd>{religionEntity.jewish}</dd>
          <dt>
            <span id="muslim">
              <Translate contentKey="apiLocationApp.religion.muslim">Muslim</Translate>
            </span>
          </dt>
          <dd>{religionEntity.muslim}</dd>
          <dt>
            <span id="sikh">
              <Translate contentKey="apiLocationApp.religion.sikh">Sikh</Translate>
            </span>
          </dt>
          <dd>{religionEntity.sikh}</dd>
          <dt>
            <span id="otherReligion">
              <Translate contentKey="apiLocationApp.religion.otherReligion">Other Religion</Translate>
            </span>
          </dt>
          <dd>{religionEntity.otherReligion}</dd>
          <dt>
            <span id="noReligion">
              <Translate contentKey="apiLocationApp.religion.noReligion">No Religion</Translate>
            </span>
          </dt>
          <dd>{religionEntity.noReligion}</dd>
          <dt>
            <span id="religionNotStated">
              <Translate contentKey="apiLocationApp.religion.religionNotStated">Religion Not Stated</Translate>
            </span>
          </dt>
          <dd>{religionEntity.religionNotStated}</dd>
        </dl>
        <Button tag={Link} to="/religion" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/religion/${religionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReligionDetail;
